export default "__VITE_ASSET__BhDqpKSb__"